import { render, staticRenderFns } from "./CollectPsDetail.vue?vue&type=template&id=1965b8ac&scoped=true&"
import script from "./CollectPsDetail.vue?vue&type=script&lang=js&"
export * from "./CollectPsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectPsDetail.vue?vue&type=style&index=0&id=1965b8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965b8ac",
  null
  
)

export default component.exports